import styled from "styled-components";

import { Button } from "@components";

export const Wrapper = styled.div`
  text-transform: initial;
`;

export const Trigger = styled.div`
  cursor: pointer;
  padding: 12px;

  &:hover {
    opacity: 0.8;
  }
`;

export const Popup = styled.div`
  box-shadow: 3px 3px 10px 0 rgb(30 42 54 / 60%);
  position: absolute;
  top: calc(100% + 1px);
  left: 0;
  z-index: 10;
  color: white;
  background-color: ${({ theme }) => theme.darkestBlue};
  padding: 5px;
  box-sizing: border-box;
`;

export const DatesBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: baseline;
  gap: 5px;
  line-height: 40px;
  font-size: 14px;
  padding: 0 6px;
`;

export const Container = styled.div`
  display: flex;
  width: 500px;
  justify-content: space-between;
`;

export const Box = styled.div`
  width: calc(50% - 3px);
  background-color: ${({ theme }) => theme.darkestBlue};
`;

export const SvgButton = styled(Button)`
  background-color: transparent;
  color: currentColor;
  border-color: currentColor;
  padding: 3px 4px;

  svg {
    margin-right: 0;
  }
`;

export const ClearButton = styled(Button)`
  background-color: transparent;
  padding: 0;
  font-size: 14px;
`;

export const YearSelector = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.quaternaryBlue};
  padding: 0 12px;
  height: 40px;

  svg {
    opacity: 0.8;
    transition: 0.2s opacity linear;

    &:hover {
      opacity: 1;
    }
  }
`;

export const Year = styled.div`
  font-size: 18px;
  cursor: default;
`;

export const MonthsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Month = styled.div<{ active?: boolean | null }>`
  width: 33.33%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s background-color linear;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => theme.lightBlue};
  }

  ${({ active, theme }) =>
    active &&
    `
    background-color: ${theme.secondaryColor};
  `}
`;
